import {
  CONFIRMED_GET_INWARD_STOCK_LIST,
  CONFIRMED_ADD_INWARD_STOCK,
  CONFIRMED_DELETE_INWARD_STOCK,
  CONFIRMED_GET_INWARD_STOCK_DETAILS,
  INWARD_STOCK_LOADING,
  INWARD_STOCK_ERROR,
} from "../types/inwardStockTypes";

const initialState = {
  inwardStocks: [],
  num_rows: 0,
  loading: false,
  error: null,
};

export default function InwardStockReducer(state = initialState, action) {
  switch (action.type) {
    case INWARD_STOCK_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CONFIRMED_GET_INWARD_STOCK_LIST:
      return {
        ...state,
        loading: false,
        inwardStocks: action.payload.inwardStocks || action.payload,
        num_rows: action.payload.num_rows || 0,
        error: null,
      };

    case CONFIRMED_ADD_INWARD_STOCK:
      const newInwardStocks = [...state.inwardStocks];
      newInwardStocks.push(action.payload);
      return {
        ...state,
        loading: false,
        inwardStocks: newInwardStocks,
        error: null,
      };
      case CONFIRMED_GET_INWARD_STOCK_DETAILS:
        return {
          ...state,
          loading: false,
          inwardDetails: action.payload,
          error: null,
        };
    case CONFIRMED_DELETE_INWARD_STOCK:
      const filteredInwards = state.inwardStocks.filter(
        (inward) => inward.inward_id !== action.payload.inward_id
      );
      return {
        ...state,
        loading: false,
        inwardStocks: filteredInwards,
        error: null,
      };

    case INWARD_STOCK_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
